// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 767px) {
    .pokedex {
        width: 90%;
        padding-top: 5%;
    }

    .pokemon__image {
        height: 10%;
        width: 20%;
        transform: translate(30%, -125%);
    }

    .pokemon__data {
        height: 20%;
        width: 55%;
        transform: translate(-21%, 55%);
    }

    .form {
        height: 9%;
        width: 53.5%;
        transform: translate(-39%, 65%);
    }

    .input__search {
        padding: 8% 6% 6% 6%;
        font-size: clamp(15px, 2vw, 18px);
    }

    .btns {
        height: 4.5%;
        width: 70%;
        gap: 5%;
    }

    .btn {
        padding: 4%;
        width: 50%;
        transform: translate(-62.5%, 220%);
    }

    .btn:active {
        font-size: 17px;
    }

    .flex-status {
        width: 60%;
        transform: translate(-28%, 150%);
        font-size: clamp(15px, 2vw, 18px);
    }

    .status {
        font-size: clamp(18px, 2vw, 20px);
        transform: translate(40%, 200%);
    }

    ul.stats.effect-text li,
    ul.re-stats.effect-text li {
        margin-bottom: clamp(5px, 2vw, 8px);
    }

    .pokemon__type {
        transform: translate(20%, 710%);
        font-size: clamp(14px, 2vw, 16px);
    }

    div.pokemon__type ul.effect-text li {
        padding: 1% 6%;
        margin: 8%;
    }

    .gear {
        top: 0.5%;
        right: 1%;
        height: 2.5%;
        width: 6.5%;
    }

    .menu-flex {
        width: 97%;
        right: 1.5%;
        top: 3.5%;
    }

    .div-flex {
        transform: translate(-21%, 0%);
    }

    #chk-1:checked ~ .switch .slider,
    #chk-2:checked ~ .switch .slider,
    #chk-3:checked ~ .switch .slider {
        transform: translate(clamp(22px, 2vw, 23px));
    }

    .loader {
        top: 23.2%;
        left: 46%;
        width: 40px;
        height: 40px;
    }

    .loader__compare1 {
        top: 11%;
        left: 45%;
        width: 40px;
        height: 40px;
    }

    .loader__compare2 {
        top: 61%;
        left: 45%;
        width: 40px;
        height: 40px;
    }

    .compare-vs {
        width: 50px;
        height: 50px;
    }

    .compare-pokemons {
        display: none;
    }

    .compare-close,
    .compare-close-dark {
        width: 20px;
        height: 20px;
        margin: 3%;
    }

    .compare-container {
        flex-direction: column;
        height: 98%;
        width: 95%;
    }

    .compare-container-dark {
        flex-direction: column;
        height: 98%;
        width: 95%;
    }

    .compare {
        height: 80%;
        width: 80%;
        margin: 2.5%;
    }

    .compare-form1,
    .compare-form2 {
        height: 38.5%;
        width: 45%;
        margin: 0%;
        transform: translate(-5%, 4%);
    }

    .input__search__compare1,
    .input__search__compare2 {
        height: 15%;
        padding: 2% 0% 2% 6%;
        font-size: clamp(13px, 2vw, 15px);
    }

    .compare-flex-status {
        font-size: clamp(16px, 2vw, 20px);
    }

    ul.compare-stats.effect-text li,
    ul.compare-re-stats.effect-text li {
        margin-bottom: clamp(4px, 2vw, 6px);
    }

    .btn-compare {
        padding: 4%;
        width: 25%;
        font-size: clamp(17px, 2vw, 20px);
        transform: translate(105%, -670%);
    }

    .btn-compare:active {
        font-size: 18px;
    }

    .pokemon__type__compare1,
    .pokemon__type__compare2 {
        transform: translate(15%, 630%);

        font-size: clamp(16px, 2vw, 18px);
    }

    .pokemon__data__compare1,
    .pokemon__data__compare2 {
        font-size: clamp(18px, 2vw, 20px);
    }

    .btn-compare-prev,
    .btn-compare-next {
        padding-top: 8%;
        padding-bottom: 27%;
        font-size: clamp(18px, 2vw, 20px);
        transform: translate(-146%, 26%);
    }

    .btn-compare-prev {
        margin-right: 170%;
    }

    .defeat__compare1,
    .draw__compare1,
    .victory__compare1 {
        height: 7%;
        width: 70%;
        transform: translate(0%, -545%);
    }

    .defeat__compare2,
    .draw__compare2,
    .victory__compare2 {
        height: 7%;
        width: 70%;
        transform: translate(0%, 170%);
    }

    .suggestions,
    .suggestions__compare1,
    .suggestions__compare2 {
        font-size: clamp(16px, 2vw, 20px);
    }

    .suggestions {
        max-height: 70px;
        width: 70.5%;
        top: 46%;
        transform: translate(1.5%, 0%);
    }

    .suggestions__compare1,
    .suggestions__compare2 {
        max-height: 376px;
        width: 97%;
        top: 11%;
    }

    .suggestions li,
    .suggestions__compare1 li,
    .suggestions__compare2 li {
        padding: 7px 11px;
    }

    .compare-info,
    .compare-info-dark {
        width: 25px;
        height: 25px;
        margin: 2.5%;
    }

    .flex-info {
        width: 95%;
        padding: 20px 10px 10px 10px;
    }

    .bg-info {
        width: 96%;
        height: 95.1%;
        top: 4%;
        padding: 10px;
    }

    .graph-adjustment {
        height: 280px !important;
        margin: 0;
    }

    .grid-info {
        display: flex;
        flex-wrap: wrap;
    }

    h1.info-fight1,
    h1.info-fight2 {
        font-size: clamp(25px, 2vw, 30px);
    }

    h1.info-fight1,
    h1.info-fight2 {
        position: relative;
    }

    .h2-status-total1,
    .h2-status-total2,
    .h2-buff-debuff1,
    .h2-buff-debuff2 {
        font-size: clamp(22px, 2vw, 25px);
    }

    .flex-status-buff-debuff {
        margin-bottom: 1px;
    }

    .compare-interrogation {
        display: none;
    }

    .div-fraquezas,
    .fraquezaInfo1,
    .fraquezaInfo2 {
        display: none;
    }
}

@media screen and (min-width: 768px) and (max-width: 1269px) {
    .pokedex {
        padding: 2%;
    }

    .pokemon__image {
        height: 10%;
        width: 15%;
        transform: translate(50%, -130%);
    }

    .pokemon__data {
        height: 20%;
        width: 31%;
        font-size: clamp(25px, 2vw, 30px);
        transform: translate(-3%, 50%);
    }

    .form {
        transform: translate(-35%, 80%);
    }

    .input__search {
        height: 15%;
        width: 215%;
        padding: 9%;
        font-size: clamp(19px, 2vw, 21px);
    }

    .btns {
        height: 4.5%;
        width: 70%;
        gap: 3.5%;
    }

    .btn {
        padding: 2.5%;
        width: 20.5%;
        transform: translate(-30%, 210%);
    }

    .btn:active {
        font-size: 17px;
    }

    .flex-status {
        width: 34%;
        height: 30%;
        transform: translate(-10%, 178%);
        font-size: clamp(20px, 2vw, 23px);
    }

    .status {
        font-size: clamp(22px, 2vw, 25px);
        transform: translate(31%, 195%);
    }

    ul.stats.effect-text li,
    ul.re-stats.effect-text li {
        margin-bottom: clamp(7px, 2vw, 10px);
    }

    .pokemon__type {
        transform: translate(20%, 695%);
        font-size: clamp(15px, 2vw, 17px);
    }

    div.pokemon__type ul.effect-text li {
        padding: 1% 6%;
        margin: 8%;
    }

    .gear {
        top: 1%;
        right: 1.5%;
        height: 3%;
        width: 5%;
    }

    .menu-flex {
        width: 40%;
        right: 1.5%;
        top: 4.5%;
    }

    .div-flex {
        transform: translate(-15%, 0%);
    }

    #chk-1:checked ~ .switch .slider,
    #chk-2:checked ~ .switch .slider,
    #chk-3:checked ~ .switch .slider {
        transform: translate(clamp(22px, 2vw, 22px));
    }

    .loader {
        top: 22%;
        left: 47.5%;
        width: 50px;
        height: 50px;
    }

    .loader__compare1 {
        top: 15%;
        left: 45%;
        width: 50px;
        height: 50px;
    }

    .loader__compare2 {
        top: 63%;
        left: 45%;
        width: 50px;
        height: 50px;
    }

    .compare-vs {
        width: 90px;
        height: 90px;
        transform: translate(0%, 20%);
    }

    .compare-close {
        width: 25px;
        height: 25px;
        margin: 3%;
    }

    .compare-close-dark {
        width: 25px;
        height: 25px;
        margin: 3%;
        padding: 0.5%;
    }

    .compare-container {
        flex-direction: column;
        height: 98%;
        width: 80%;
    }

    .compare-container-dark {
        flex-direction: column;
        height: 98%;
        width: 80%;
    }

    .compare {
        height: 80%;
        width: 80%;
        margin: 2.5%;
    }

    .mt-compare {
        margin: 8.5% 2.5% 2.5% 2.5% !important;
    }

    .compare-form1,
    .compare-form2 {
        height: 40%;
        width: 45%;
        margin: 2%;
        transform: translate(-2%, 5.5%);
    }

    .input__search__compare1,
    .input__search__compare2 {
        height: 20%;
        padding: 2% 0% 2% 6%;
        font-size: clamp(21px, 2vw, 22px);
        transform: translate(-1.5%, 0%);
    }

    .compare-flex-status {
        font-size: clamp(23px, 2vw, 25px);
        transform: translate(30%, 107%);
    }

    ul.compare-stats.effect-text li,
    ul.compare-re-stats.effect-text li {
        margin-bottom: clamp(4px, 2vw, 6px);
    }

    .btn-compare {
        padding: 2.5% 4%;
        width: 11%;
        font-size: clamp(17px, 2vw, 20px);
        transform: translate(145%, -685%);
    }

    .btn-compare:active {
        font-size: 18px;
    }

    .pokemon__data__compare1,
    .pokemon__data__compare2 {
        font-size: clamp(25px, 2vw, 27px);
    }

    .btn-compare-prev,
    .btn-compare-next {
        padding-top: 9.5%;
        padding-bottom: 22.5%;
        transform: translate(-150%, 46%);
    }

    .btn-compare-prev {
        margin-right: 170%;
    }

    .defeat__compare1,
    .draw__compare1,
    .victory__compare1 {
        height: 7%;
        width: 70%;
        transform: translate(0%, -470%);
    }

    .defeat__compare2,
    .draw__compare2,
    .victory__compare2 {
        height: 7%;
        width: 70%;
        transform: translate(0%, 220%);
    }

    .pokemon__image__compare1,
    .pokemon__image__compare2 {
        transform: translate(18%, -40%);
    }

    .suggestions,
    .suggestions__compare1,
    .suggestions__compare2 {
        font-size: clamp(19px, 2vw, 21px);
    }

    .suggestions {
        max-height: 85px;
        width: 40%;
        top: 45.5%;
        transform: translate(1.5%, 0%);
    }

    .suggestions__compare1,
    .suggestions__compare2 {
        max-height: 380px;
        width: 92%;
        top: 17%;
    }

    .suggestions li,
    .suggestions__compare1 li,
    .suggestions__compare2 li {
        padding: 9px 11px;
    }

    .compare-info,
    .compare-info-dark {
        width: 30px;
        height: 30px;
        margin: 2.5%;
    }

    .flex-info {
        width: 98%;
        padding: 15px 10px 10px 10px;
    }

    .bg-info {
        width: 96%;
        height: 94.5%;
        top: 4.5%;
        padding: 10px;
    }

    .graph-adjustment {
        height: 400px !important;
        margin: 0;
    }

    .grid-info {
        display: flex;
        flex-wrap: wrap;
    }

    .info-fight1,
    .info-fight2 {
        margin: 1.5% 1.5% 1.5% 1.5%;
    }

    h1.info-fight1,
    h1.info-fight2 {
        font-size: clamp(30px, 2vw, 32px);
    }

    h1.info-fight1,
    h1.info-fight2 {
        position: relative;
        transform: translate(0%, 50%);
    }

    .h2-status-total1,
    .h2-status-total2,
    .h2-buff-debuff1,
    .h2-buff-debuff2 {
        font-size: clamp(23px, 2vw, 25px);
    }

    .flex-status-buff-debuff {
        margin-bottom: 1px;
    }

    .compare-interrogation {
        display: none;
    }

    .div-fraquezas,
    .fraquezaInfo1,
    .fraquezaInfo2 {
        display: none;
    }
}

@media screen and (min-width: 1270px) and (max-width: 1850px) {
    .pokedex {
        width: 65%;
        padding-top: 2.5%;
    }

    .pokemon__image {
        height: 20%;
        width: 10%;
        transform: translate(-80%, 50%);
    }

    .pokemon__data {
        height: 20%;
        width: 20%;
        font-size: clamp(25px, 2vw, 30px);
        transform: translate(-62%, 171%);
    }

    .form {
        transform: translate(-92%, 215%);
    }

    .input__search {
        height: 15%;
        width: 133%;
        padding: 8%;
        font-size: clamp(17px, 2vw, 19px);
    }

    .btns {
        height: 6%;
        width: 70%;
        gap: 2%;
    }

    .btn {
        padding: 1%;
        width: 14.7%;
        transform: translate(-130%, 830%);
    }

    .btn:active {
        font-size: 20px;
    }

    .flex-status {
        width: 20%;
        font-size: clamp(19px, 2vw, 22px);
        transform: translate(100%, 89%);
    }

    .status {
        font-size: clamp(20px, 2vw, 28px);
        transform: translate(128%, 20%);
    }

    ul.stats.effect-text li,
    ul.re-stats.effect-text li {
        margin-bottom: clamp(10px, 2vw, 12px);
    }

    .pokemon__type {
        font-size: clamp(17px, 2vw, 19px);
        transform: translate(103%, 630%);
    }

    .gear {
        top: 1%;
        right: 1%;
        height: 5%;
        width: 3%;
    }

    .menu-flex {
        width: 25%;
        right: 1.5%;
        top: 6.5%;
    }

    .div-flex {
        transform: translate(-15.5%, 0%);
    }

    .loader {
        top: 38.5%;
        left: 31.5%;
    }

    .compare-vs {
        width: 110px;
        height: 110px;
        transform: translate(0%, 20%);
    }

    .compare-close,
    .compare-close-dark {
        width: 30px;
        height: 30px;
        margin: 2.5%;
    }

    .compare-container {
        height: 95%;
        width: 80%;
    }

    .compare-container-dark {
        height: 95%;
        width: 80%;
    }

    .compare {
        height: 80%;
        width: 40%;
        margin: 2.5%;
    }

    .compare-form1,
    .compare-form2 {
        height: 40%;
        width: 45%;
        margin: 2%;
        transform: translate(-4%, 5%);
    }

    .input__search__compare1,
    .input__search__compare2 {
        height: 20%;
        padding: 2% 0% 0% 6%;
        font-size: clamp(17px, 2vw, 19px);
    }

    .compare-flex-status {
        font-size: clamp(23px, 2vw, 23px);
        transform: translate(30%, 108.5%);
    }

    ul.compare-stats.effect-text li,
    ul.compare-re-stats.effect-text li {
        margin-bottom: clamp(4px, 2vw, 6px);
    }

    .btn-compare {
        padding: 1.4% 4% 3.8% 4%;
        width: 5%;
        font-size: clamp(17px, 2vw, 20px);
        transform: translate(4%, -300%);
    }

    .btn-compare:active {
        font-size: 18px;
    }

    .pokemon__data__compare1,
    .pokemon__data__compare2 {
        font-size: clamp(25px, 2vw, 27px);
    }

    .btn-compare-prev,
    .btn-compare-next {
        padding-top: 11.5%;
        padding-bottom: 25%;
        transform: translate(-148%, 45%);
    }

    .btn-compare-prev {
        margin-right: 170%;
    }

    .defeat__compare1,
    .draw__compare1,
    .victory__compare1 {
        height: 10%;
        width: 35%;
        transform: translate(-64%, -200%);
    }

    .defeat__compare2,
    .draw__compare2,
    .victory__compare2 {
        height: 10%;
        width: 35%;
        transform: translate(64%, -200%);
    }

    .suggestions,
    .suggestions__compare1,
    .suggestions__compare2 {
        font-size: clamp(19px, 2vw, 21px);
    }

    .suggestions {
        max-height: 125px;
        width: 25.5%;
        top: 76%;
        left: 20.5%;
        transform: translate(1.5%, 0%);
    }

    .suggestions__compare1,
    .suggestions__compare2 {
        max-height: 375px;
        width: 94.5%;
        top: 15%;
    }

    .suggestions li,
    .suggestions__compare1 li,
    .suggestions__compare2 li {
        padding: 7px 11px;
    }

    .compare-info,
    .compare-info-dark {
        width: 35px;
        height: 35px;
        margin: 2.3%;
    }

    .flex-info {
        width: 95%;
    }

    .bg-info {
        width: 95%;
        height: 88%;
        left: 2.5%;
        top: 9%;
    }

    .graph-adjustment {
        height: 350px;
        width: 350px;
        margin-top: 20px;
    }

    .i-status1-message {
        transform: translate(82%, -68%);
    }

    .i-status2-message {
        transform: translate(-12%, -68%);
    }

    .i-status1-message,
    .i-status2-message {
        width: 30%;
        height: 20%;
    }

    .i-buff-debuff1-message {
        transform: translate(69%, -60%);
    }

    .i-buff-debuff2-message {
        transform: translate(-27%, -60%);
    }

    .i-buff-debuff1-message,
    .i-buff-debuff2-message {
        width: 50%;
        height: 33%;
    }

    .div-fraquezas {
        margin-top: 1.5%;
    }

    .fraquezaInfo1,
    .fraquezaInfo2 {
        font-size: 14px;
    }

    .i-fraquezas-message {
        width: 95%;
        height: 89%;
        transform: translate(0%, -53%);
        padding: 0px 20px 20px 20px;
    }

    .flex-fraquezas-h2 {
        justify-content: center !important;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .fraqueza-types,
    .fraqueza-types-three,
    .fraqueza-types-four,
    .fraqueza-types-five {
        font-size: clamp(16px, 2vw, 17px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/mediaquery.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,+BAA+B;IACnC;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,+BAA+B;IACnC;;IAEA;QACI,oBAAoB;QACpB,iCAAiC;IACrC;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,OAAO;IACX;;IAEA;QACI,WAAW;QACX,UAAU;QACV,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,gCAAgC;QAChC,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,+BAA+B;QAC/B,iCAAiC;IACrC;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,SAAS;QACT,SAAS;QACT,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;QAGI,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;QACV,YAAY;IAChB;;IAEA;;QAEI,aAAa;QACb,UAAU;QACV,UAAU;QACV,6BAA6B;IACjC;;IAEA;;QAEI,WAAW;QACX,oBAAoB;QACpB,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,iCAAiC;QACjC,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,+BAA+B;;QAE/B,iCAAiC;IACrC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,eAAe;QACf,mBAAmB;QACnB,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,UAAU;QACV,UAAU;QACV,+BAA+B;IACnC;;IAEA;;;QAGI,UAAU;QACV,UAAU;QACV,8BAA8B;IAClC;;IAEA;;;QAGI,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,QAAQ;QACR,8BAA8B;IAClC;;IAEA;;QAEI,iBAAiB;QACjB,UAAU;QACV,QAAQ;IACZ;;IAEA;;;QAGI,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,aAAa;QACb,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;;;QAII,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,iCAAiC;IACrC;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,SAAS;IACb;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,gCAAgC;QAChC,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;;QAEI,oCAAoC;IACxC;;IAEA;QACI,+BAA+B;QAC/B,iCAAiC;IACrC;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,OAAO;QACP,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;QAGI,4CAA4C;IAChD;;IAEA;QACI,QAAQ;QACR,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;;QAEI,WAAW;QACX,UAAU;QACV,UAAU;QACV,+BAA+B;IACnC;;IAEA;;QAEI,WAAW;QACX,oBAAoB;QACpB,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,iCAAiC;QACjC,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,iBAAiB;QACjB,qBAAqB;QACrB,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,UAAU;QACV,UAAU;QACV,+BAA+B;IACnC;;IAEA;;;QAGI,UAAU;QACV,UAAU;QACV,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;;QAGI,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,UAAU;QACV,8BAA8B;IAClC;;IAEA;;QAEI,iBAAiB;QACjB,UAAU;QACV,QAAQ;IACZ;;IAEA;;;QAGI,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,aAAa;QACb,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;;;;QAII,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,+BAA+B;IACnC;;IAEA;QACI,WAAW;QACX,UAAU;QACV,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,iCAAiC;IACrC;;IAEA;QACI,UAAU;QACV,UAAU;QACV,OAAO;IACX;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;;QAEI,qCAAqC;IACzC;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,OAAO;QACP,SAAS;QACT,UAAU;QACV,SAAS;IACb;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;IACb;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,6BAA6B;IACjC;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;QACV,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,UAAU;QACV,UAAU;QACV,6BAA6B;IACjC;;IAEA;;QAEI,WAAW;QACX,oBAAoB;QACpB,iCAAiC;IACrC;;IAEA;QACI,iCAAiC;QACjC,iCAAiC;IACrC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;QACI,wBAAwB;QACxB,SAAS;QACT,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,WAAW;QACX,UAAU;QACV,iCAAiC;IACrC;;IAEA;;;QAGI,WAAW;QACX,UAAU;QACV,gCAAgC;IACpC;;IAEA;;;QAGI,iCAAiC;IACrC;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,QAAQ;QACR,WAAW;QACX,8BAA8B;IAClC;;IAEA;;QAEI,iBAAiB;QACjB,YAAY;QACZ,QAAQ;IACZ;;IAEA;;;QAGI,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,WAAW;QACX,UAAU;QACV,OAAO;IACX;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,kCAAkC;QAClC,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;;;QAII,iCAAiC;IACrC;AACJ","sourcesContent":["@media screen and (max-width: 767px) {\n    .pokedex {\n        width: 90%;\n        padding-top: 5%;\n    }\n\n    .pokemon__image {\n        height: 10%;\n        width: 20%;\n        transform: translate(30%, -125%);\n    }\n\n    .pokemon__data {\n        height: 20%;\n        width: 55%;\n        transform: translate(-21%, 55%);\n    }\n\n    .form {\n        height: 9%;\n        width: 53.5%;\n        transform: translate(-39%, 65%);\n    }\n\n    .input__search {\n        padding: 8% 6% 6% 6%;\n        font-size: clamp(15px, 2vw, 18px);\n    }\n\n    .btns {\n        height: 4.5%;\n        width: 70%;\n        gap: 5%;\n    }\n\n    .btn {\n        padding: 4%;\n        width: 50%;\n        transform: translate(-62.5%, 220%);\n    }\n\n    .btn:active {\n        font-size: 17px;\n    }\n\n    .flex-status {\n        width: 60%;\n        transform: translate(-28%, 150%);\n        font-size: clamp(15px, 2vw, 18px);\n    }\n\n    .status {\n        font-size: clamp(18px, 2vw, 20px);\n        transform: translate(40%, 200%);\n    }\n\n    ul.stats.effect-text li,\n    ul.re-stats.effect-text li {\n        margin-bottom: clamp(5px, 2vw, 8px);\n    }\n\n    .pokemon__type {\n        transform: translate(20%, 710%);\n        font-size: clamp(14px, 2vw, 16px);\n    }\n\n    div.pokemon__type ul.effect-text li {\n        padding: 1% 6%;\n        margin: 8%;\n    }\n\n    .gear {\n        top: 0.5%;\n        right: 1%;\n        height: 2.5%;\n        width: 6.5%;\n    }\n\n    .menu-flex {\n        width: 97%;\n        right: 1.5%;\n        top: 3.5%;\n    }\n\n    .div-flex {\n        transform: translate(-21%, 0%);\n    }\n\n    #chk-1:checked ~ .switch .slider,\n    #chk-2:checked ~ .switch .slider,\n    #chk-3:checked ~ .switch .slider {\n        transform: translate(clamp(22px, 2vw, 23px));\n    }\n\n    .loader {\n        top: 23.2%;\n        left: 46%;\n        width: 40px;\n        height: 40px;\n    }\n\n    .loader__compare1 {\n        top: 11%;\n        left: 45%;\n        width: 40px;\n        height: 40px;\n    }\n\n    .loader__compare2 {\n        top: 61%;\n        left: 45%;\n        width: 40px;\n        height: 40px;\n    }\n\n    .compare-vs {\n        width: 50px;\n        height: 50px;\n    }\n\n    .compare-pokemons {\n        display: none;\n    }\n\n    .compare-close,\n    .compare-close-dark {\n        width: 20px;\n        height: 20px;\n        margin: 3%;\n    }\n\n    .compare-container {\n        flex-direction: column;\n        height: 98%;\n        width: 95%;\n    }\n\n    .compare-container-dark {\n        flex-direction: column;\n        height: 98%;\n        width: 95%;\n    }\n\n    .compare {\n        height: 80%;\n        width: 80%;\n        margin: 2.5%;\n    }\n\n    .compare-form1,\n    .compare-form2 {\n        height: 38.5%;\n        width: 45%;\n        margin: 0%;\n        transform: translate(-5%, 4%);\n    }\n\n    .input__search__compare1,\n    .input__search__compare2 {\n        height: 15%;\n        padding: 2% 0% 2% 6%;\n        font-size: clamp(13px, 2vw, 15px);\n    }\n\n    .compare-flex-status {\n        font-size: clamp(16px, 2vw, 20px);\n    }\n\n    ul.compare-stats.effect-text li,\n    ul.compare-re-stats.effect-text li {\n        margin-bottom: clamp(4px, 2vw, 6px);\n    }\n\n    .btn-compare {\n        padding: 4%;\n        width: 25%;\n        font-size: clamp(17px, 2vw, 20px);\n        transform: translate(105%, -670%);\n    }\n\n    .btn-compare:active {\n        font-size: 18px;\n    }\n\n    .pokemon__type__compare1,\n    .pokemon__type__compare2 {\n        transform: translate(15%, 630%);\n\n        font-size: clamp(16px, 2vw, 18px);\n    }\n\n    .pokemon__data__compare1,\n    .pokemon__data__compare2 {\n        font-size: clamp(18px, 2vw, 20px);\n    }\n\n    .btn-compare-prev,\n    .btn-compare-next {\n        padding-top: 8%;\n        padding-bottom: 27%;\n        font-size: clamp(18px, 2vw, 20px);\n        transform: translate(-146%, 26%);\n    }\n\n    .btn-compare-prev {\n        margin-right: 170%;\n    }\n\n    .defeat__compare1,\n    .draw__compare1,\n    .victory__compare1 {\n        height: 7%;\n        width: 70%;\n        transform: translate(0%, -545%);\n    }\n\n    .defeat__compare2,\n    .draw__compare2,\n    .victory__compare2 {\n        height: 7%;\n        width: 70%;\n        transform: translate(0%, 170%);\n    }\n\n    .suggestions,\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        font-size: clamp(16px, 2vw, 20px);\n    }\n\n    .suggestions {\n        max-height: 70px;\n        width: 70.5%;\n        top: 46%;\n        transform: translate(1.5%, 0%);\n    }\n\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        max-height: 376px;\n        width: 97%;\n        top: 11%;\n    }\n\n    .suggestions li,\n    .suggestions__compare1 li,\n    .suggestions__compare2 li {\n        padding: 7px 11px;\n    }\n\n    .compare-info,\n    .compare-info-dark {\n        width: 25px;\n        height: 25px;\n        margin: 2.5%;\n    }\n\n    .flex-info {\n        width: 95%;\n        padding: 20px 10px 10px 10px;\n    }\n\n    .bg-info {\n        width: 96%;\n        height: 95.1%;\n        top: 4%;\n        padding: 10px;\n    }\n\n    .graph-adjustment {\n        height: 280px !important;\n        margin: 0;\n    }\n\n    .grid-info {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    h1.info-fight1,\n    h1.info-fight2 {\n        font-size: clamp(25px, 2vw, 30px);\n    }\n\n    h1.info-fight1,\n    h1.info-fight2 {\n        position: relative;\n    }\n\n    .h2-status-total1,\n    .h2-status-total2,\n    .h2-buff-debuff1,\n    .h2-buff-debuff2 {\n        font-size: clamp(22px, 2vw, 25px);\n    }\n\n    .flex-status-buff-debuff {\n        margin-bottom: 1px;\n    }\n\n    .compare-interrogation {\n        display: none;\n    }\n\n    .div-fraquezas,\n    .fraquezaInfo1,\n    .fraquezaInfo2 {\n        display: none;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1269px) {\n    .pokedex {\n        padding: 2%;\n    }\n\n    .pokemon__image {\n        height: 10%;\n        width: 15%;\n        transform: translate(50%, -130%);\n    }\n\n    .pokemon__data {\n        height: 20%;\n        width: 31%;\n        font-size: clamp(25px, 2vw, 30px);\n        transform: translate(-3%, 50%);\n    }\n\n    .form {\n        transform: translate(-35%, 80%);\n    }\n\n    .input__search {\n        height: 15%;\n        width: 215%;\n        padding: 9%;\n        font-size: clamp(19px, 2vw, 21px);\n    }\n\n    .btns {\n        height: 4.5%;\n        width: 70%;\n        gap: 3.5%;\n    }\n\n    .btn {\n        padding: 2.5%;\n        width: 20.5%;\n        transform: translate(-30%, 210%);\n    }\n\n    .btn:active {\n        font-size: 17px;\n    }\n\n    .flex-status {\n        width: 34%;\n        height: 30%;\n        transform: translate(-10%, 178%);\n        font-size: clamp(20px, 2vw, 23px);\n    }\n\n    .status {\n        font-size: clamp(22px, 2vw, 25px);\n        transform: translate(31%, 195%);\n    }\n\n    ul.stats.effect-text li,\n    ul.re-stats.effect-text li {\n        margin-bottom: clamp(7px, 2vw, 10px);\n    }\n\n    .pokemon__type {\n        transform: translate(20%, 695%);\n        font-size: clamp(15px, 2vw, 17px);\n    }\n\n    div.pokemon__type ul.effect-text li {\n        padding: 1% 6%;\n        margin: 8%;\n    }\n\n    .gear {\n        top: 1%;\n        right: 1.5%;\n        height: 3%;\n        width: 5%;\n    }\n\n    .menu-flex {\n        width: 40%;\n        right: 1.5%;\n        top: 4.5%;\n    }\n\n    .div-flex {\n        transform: translate(-15%, 0%);\n    }\n\n    #chk-1:checked ~ .switch .slider,\n    #chk-2:checked ~ .switch .slider,\n    #chk-3:checked ~ .switch .slider {\n        transform: translate(clamp(22px, 2vw, 22px));\n    }\n\n    .loader {\n        top: 22%;\n        left: 47.5%;\n        width: 50px;\n        height: 50px;\n    }\n\n    .loader__compare1 {\n        top: 15%;\n        left: 45%;\n        width: 50px;\n        height: 50px;\n    }\n\n    .loader__compare2 {\n        top: 63%;\n        left: 45%;\n        width: 50px;\n        height: 50px;\n    }\n\n    .compare-vs {\n        width: 90px;\n        height: 90px;\n        transform: translate(0%, 20%);\n    }\n\n    .compare-close {\n        width: 25px;\n        height: 25px;\n        margin: 3%;\n    }\n\n    .compare-close-dark {\n        width: 25px;\n        height: 25px;\n        margin: 3%;\n        padding: 0.5%;\n    }\n\n    .compare-container {\n        flex-direction: column;\n        height: 98%;\n        width: 80%;\n    }\n\n    .compare-container-dark {\n        flex-direction: column;\n        height: 98%;\n        width: 80%;\n    }\n\n    .compare {\n        height: 80%;\n        width: 80%;\n        margin: 2.5%;\n    }\n\n    .mt-compare {\n        margin: 8.5% 2.5% 2.5% 2.5% !important;\n    }\n\n    .compare-form1,\n    .compare-form2 {\n        height: 40%;\n        width: 45%;\n        margin: 2%;\n        transform: translate(-2%, 5.5%);\n    }\n\n    .input__search__compare1,\n    .input__search__compare2 {\n        height: 20%;\n        padding: 2% 0% 2% 6%;\n        font-size: clamp(21px, 2vw, 22px);\n        transform: translate(-1.5%, 0%);\n    }\n\n    .compare-flex-status {\n        font-size: clamp(23px, 2vw, 25px);\n        transform: translate(30%, 107%);\n    }\n\n    ul.compare-stats.effect-text li,\n    ul.compare-re-stats.effect-text li {\n        margin-bottom: clamp(4px, 2vw, 6px);\n    }\n\n    .btn-compare {\n        padding: 2.5% 4%;\n        width: 11%;\n        font-size: clamp(17px, 2vw, 20px);\n        transform: translate(145%, -685%);\n    }\n\n    .btn-compare:active {\n        font-size: 18px;\n    }\n\n    .pokemon__data__compare1,\n    .pokemon__data__compare2 {\n        font-size: clamp(25px, 2vw, 27px);\n    }\n\n    .btn-compare-prev,\n    .btn-compare-next {\n        padding-top: 9.5%;\n        padding-bottom: 22.5%;\n        transform: translate(-150%, 46%);\n    }\n\n    .btn-compare-prev {\n        margin-right: 170%;\n    }\n\n    .defeat__compare1,\n    .draw__compare1,\n    .victory__compare1 {\n        height: 7%;\n        width: 70%;\n        transform: translate(0%, -470%);\n    }\n\n    .defeat__compare2,\n    .draw__compare2,\n    .victory__compare2 {\n        height: 7%;\n        width: 70%;\n        transform: translate(0%, 220%);\n    }\n\n    .pokemon__image__compare1,\n    .pokemon__image__compare2 {\n        transform: translate(18%, -40%);\n    }\n\n    .suggestions,\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        font-size: clamp(19px, 2vw, 21px);\n    }\n\n    .suggestions {\n        max-height: 85px;\n        width: 40%;\n        top: 45.5%;\n        transform: translate(1.5%, 0%);\n    }\n\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        max-height: 380px;\n        width: 92%;\n        top: 17%;\n    }\n\n    .suggestions li,\n    .suggestions__compare1 li,\n    .suggestions__compare2 li {\n        padding: 9px 11px;\n    }\n\n    .compare-info,\n    .compare-info-dark {\n        width: 30px;\n        height: 30px;\n        margin: 2.5%;\n    }\n\n    .flex-info {\n        width: 98%;\n        padding: 15px 10px 10px 10px;\n    }\n\n    .bg-info {\n        width: 96%;\n        height: 94.5%;\n        top: 4.5%;\n        padding: 10px;\n    }\n\n    .graph-adjustment {\n        height: 400px !important;\n        margin: 0;\n    }\n\n    .grid-info {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .info-fight1,\n    .info-fight2 {\n        margin: 1.5% 1.5% 1.5% 1.5%;\n    }\n\n    h1.info-fight1,\n    h1.info-fight2 {\n        font-size: clamp(30px, 2vw, 32px);\n    }\n\n    h1.info-fight1,\n    h1.info-fight2 {\n        position: relative;\n        transform: translate(0%, 50%);\n    }\n\n    .h2-status-total1,\n    .h2-status-total2,\n    .h2-buff-debuff1,\n    .h2-buff-debuff2 {\n        font-size: clamp(23px, 2vw, 25px);\n    }\n\n    .flex-status-buff-debuff {\n        margin-bottom: 1px;\n    }\n\n    .compare-interrogation {\n        display: none;\n    }\n\n    .div-fraquezas,\n    .fraquezaInfo1,\n    .fraquezaInfo2 {\n        display: none;\n    }\n}\n\n@media screen and (min-width: 1270px) and (max-width: 1850px) {\n    .pokedex {\n        width: 65%;\n        padding-top: 2.5%;\n    }\n\n    .pokemon__image {\n        height: 20%;\n        width: 10%;\n        transform: translate(-80%, 50%);\n    }\n\n    .pokemon__data {\n        height: 20%;\n        width: 20%;\n        font-size: clamp(25px, 2vw, 30px);\n        transform: translate(-62%, 171%);\n    }\n\n    .form {\n        transform: translate(-92%, 215%);\n    }\n\n    .input__search {\n        height: 15%;\n        width: 133%;\n        padding: 8%;\n        font-size: clamp(17px, 2vw, 19px);\n    }\n\n    .btns {\n        height: 6%;\n        width: 70%;\n        gap: 2%;\n    }\n\n    .btn {\n        padding: 1%;\n        width: 14.7%;\n        transform: translate(-130%, 830%);\n    }\n\n    .btn:active {\n        font-size: 20px;\n    }\n\n    .flex-status {\n        width: 20%;\n        font-size: clamp(19px, 2vw, 22px);\n        transform: translate(100%, 89%);\n    }\n\n    .status {\n        font-size: clamp(20px, 2vw, 28px);\n        transform: translate(128%, 20%);\n    }\n\n    ul.stats.effect-text li,\n    ul.re-stats.effect-text li {\n        margin-bottom: clamp(10px, 2vw, 12px);\n    }\n\n    .pokemon__type {\n        font-size: clamp(17px, 2vw, 19px);\n        transform: translate(103%, 630%);\n    }\n\n    .gear {\n        top: 1%;\n        right: 1%;\n        height: 5%;\n        width: 3%;\n    }\n\n    .menu-flex {\n        width: 25%;\n        right: 1.5%;\n        top: 6.5%;\n    }\n\n    .div-flex {\n        transform: translate(-15.5%, 0%);\n    }\n\n    .loader {\n        top: 38.5%;\n        left: 31.5%;\n    }\n\n    .compare-vs {\n        width: 110px;\n        height: 110px;\n        transform: translate(0%, 20%);\n    }\n\n    .compare-close,\n    .compare-close-dark {\n        width: 30px;\n        height: 30px;\n        margin: 2.5%;\n    }\n\n    .compare-container {\n        height: 95%;\n        width: 80%;\n    }\n\n    .compare-container-dark {\n        height: 95%;\n        width: 80%;\n    }\n\n    .compare {\n        height: 80%;\n        width: 40%;\n        margin: 2.5%;\n    }\n\n    .compare-form1,\n    .compare-form2 {\n        height: 40%;\n        width: 45%;\n        margin: 2%;\n        transform: translate(-4%, 5%);\n    }\n\n    .input__search__compare1,\n    .input__search__compare2 {\n        height: 20%;\n        padding: 2% 0% 0% 6%;\n        font-size: clamp(17px, 2vw, 19px);\n    }\n\n    .compare-flex-status {\n        font-size: clamp(23px, 2vw, 23px);\n        transform: translate(30%, 108.5%);\n    }\n\n    ul.compare-stats.effect-text li,\n    ul.compare-re-stats.effect-text li {\n        margin-bottom: clamp(4px, 2vw, 6px);\n    }\n\n    .btn-compare {\n        padding: 1.4% 4% 3.8% 4%;\n        width: 5%;\n        font-size: clamp(17px, 2vw, 20px);\n        transform: translate(4%, -300%);\n    }\n\n    .btn-compare:active {\n        font-size: 18px;\n    }\n\n    .pokemon__data__compare1,\n    .pokemon__data__compare2 {\n        font-size: clamp(25px, 2vw, 27px);\n    }\n\n    .btn-compare-prev,\n    .btn-compare-next {\n        padding-top: 11.5%;\n        padding-bottom: 25%;\n        transform: translate(-148%, 45%);\n    }\n\n    .btn-compare-prev {\n        margin-right: 170%;\n    }\n\n    .defeat__compare1,\n    .draw__compare1,\n    .victory__compare1 {\n        height: 10%;\n        width: 35%;\n        transform: translate(-64%, -200%);\n    }\n\n    .defeat__compare2,\n    .draw__compare2,\n    .victory__compare2 {\n        height: 10%;\n        width: 35%;\n        transform: translate(64%, -200%);\n    }\n\n    .suggestions,\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        font-size: clamp(19px, 2vw, 21px);\n    }\n\n    .suggestions {\n        max-height: 125px;\n        width: 25.5%;\n        top: 76%;\n        left: 20.5%;\n        transform: translate(1.5%, 0%);\n    }\n\n    .suggestions__compare1,\n    .suggestions__compare2 {\n        max-height: 375px;\n        width: 94.5%;\n        top: 15%;\n    }\n\n    .suggestions li,\n    .suggestions__compare1 li,\n    .suggestions__compare2 li {\n        padding: 7px 11px;\n    }\n\n    .compare-info,\n    .compare-info-dark {\n        width: 35px;\n        height: 35px;\n        margin: 2.3%;\n    }\n\n    .flex-info {\n        width: 95%;\n    }\n\n    .bg-info {\n        width: 95%;\n        height: 88%;\n        left: 2.5%;\n        top: 9%;\n    }\n\n    .graph-adjustment {\n        height: 350px;\n        width: 350px;\n        margin-top: 20px;\n    }\n\n    .i-status1-message {\n        transform: translate(82%, -68%);\n    }\n\n    .i-status2-message {\n        transform: translate(-12%, -68%);\n    }\n\n    .i-status1-message,\n    .i-status2-message {\n        width: 30%;\n        height: 20%;\n    }\n\n    .i-buff-debuff1-message {\n        transform: translate(69%, -60%);\n    }\n\n    .i-buff-debuff2-message {\n        transform: translate(-27%, -60%);\n    }\n\n    .i-buff-debuff1-message,\n    .i-buff-debuff2-message {\n        width: 50%;\n        height: 33%;\n    }\n\n    .div-fraquezas {\n        margin-top: 1.5%;\n    }\n\n    .fraquezaInfo1,\n    .fraquezaInfo2 {\n        font-size: 14px;\n    }\n\n    .i-fraquezas-message {\n        width: 95%;\n        height: 89%;\n        transform: translate(0%, -53%);\n        padding: 0px 20px 20px 20px;\n    }\n\n    .flex-fraquezas-h2 {\n        justify-content: center !important;\n        margin-bottom: 10px;\n        margin-top: 10px;\n    }\n\n    .fraqueza-types,\n    .fraqueza-types-three,\n    .fraqueza-types-four,\n    .fraqueza-types-five {\n        font-size: clamp(16px, 2vw, 17px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
